import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { MatOption, ThemePalette } from '@angular/material/core';
import { AlertService } from './../../service/alert.service';
import { User } from './../../model/user.model';
import { Validators } from '@angular/forms';
import { FormBuilder, FormControl, FormGroup, FormArray } from '@angular/forms';
import { Grupos } from './../../model/grupos.model';
import { GruposService } from './../../service/grupos.service';
import { UsuariosService } from './../../service/usuarios.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ClientesService } from 'src/app/service/clientes.service';
import { Cliente } from 'src/app/model/cliente.model';
import { MatSelect } from '@angular/material/select';
import { SelecionarTodosService } from 'src/app/service/selecionar-todos.service';

@Component({
  selector: 'app-criar-usuario',
  templateUrl: './criar-usuario.component.html',
  styleUrls: ['./criar-usuario.component.css']
})
export class CriarUsuarioComponent implements OnInit {

  formUsuario!: FormGroup;
  grupos!: Grupos[];
  clientes!: Cliente[];
  clientesId!: number;
  gruposId!: number;
  usuario!: User;
  validaForm = false
  load = false;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;

  @ViewChild('opcaoTodosClientes') opcaoTodosClientes!: MatOption;
  @ViewChild('selectClientes') selectClientes!: MatSelect;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private service: UsuariosService,
    private serviceGrupos: GruposService,
    private serviceClientes: ClientesService,
    private alertService: AlertService,
    public selecionarService: SelecionarTodosService
  ) {
    this.formUsuario = this.formBuilder.group({
      vc_nome: new FormControl,
      vc_login: new FormControl('', [Validators.email, Validators.required]),
      vc_senha: new FormControl,
      vc_telefone: new FormControl,
      ar_clientes: new FormControl([], [Validators.required]),
      ar_grupos: new FormControl([], [Validators.required])
    })
  }

  ngOnInit(): void {
    this.listarGrupo();
    this.formUsuario.get('vc_telefone')?.setValue('55')
  }

  listarGrupo(): void {
    this.serviceGrupos.listarService().subscribe(resp => {
      this.grupos = resp;
      this.listarCliente();
    })
  }

  listarCliente(): void {
    this.serviceClientes.listarServiceClientes().subscribe(resp => {
      this.clientes = resp;
      this.validaForm = true
    })
  }

  cadastrar(): void {
    this.load = true
    if (this.opcaoTodosClientes.selected) {
      this.formUsuario.value.ar_clientes = this.formUsuario.value.ar_clientes.filter((cliente: any) => cliente !== undefined);
    }
    this.service.cadastrarService(this.formUsuario.value).subscribe((resp) => {
      this.load = false
      this.usuario = resp;
      this.alertService.success();
      this.router.navigate(['configuracao/usuarios']);
    }, error => {
      this.load = false
      if (typeof error == 'object') {
        if (typeof error.error.mensagem == 'string') {
          this.alertService.error(error.error.mensagem);
        } else {
          this.alertService.error(error.error.mensagem[0]);
        }
      } else {
        this.alertService.error(error)
      }
    }
    )
  }

  onCheckboxChangeCliente(e: any) {
    const clientes: FormArray = this.formUsuario.get('ar_clientes') as FormArray;
    if (e.target.checked) {
      clientes.push(new FormControl(parseInt(e.target.value)));
    } else {
      const indexCliente = clientes.controls.findIndex(x => x.value === e.target.value);
      clientes.removeAt(indexCliente);
    }
  }

  onCheckboxChangeGrupo(e: any) {
    const grupos: FormArray = this.formUsuario.get('ar_grupos') as FormArray;
    if (e.target.checked) {
      grupos.push(new FormControl(parseInt(e.target.value)));
    } else {
      const indexGrupo = grupos.controls.findIndex(x => x.value === e.target.value);
      grupos.removeAt(indexGrupo);
    }
  }

  cancel() {
    this.router.navigate(['configuracao/usuarios']);
  }

  onInputChange() {
    if (this.formUsuario.get('vc_telefone')?.value.length < 2) {
      this.formUsuario.get('vc_telefone')?.setValue(this.formUsuario.get('vc_telefone')?.value.padEnd(2, '55'));
    }
  }

}
